import { createComponent } from './utils/create-component';
import { ref, computed, watch, resolveComponent, openBlock, createElementBlock, normalizeClass, renderSlot, withDirectives, createElementVNode, normalizeStyle, createBlock, Fragment, createTextVNode, toDisplayString, createCommentVNode, vShow } from 'vue';
import propTypes from './utils/prop-types';
import Icon from './icon';
import { isDef } from './utils/validate';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * kid token
   */
  token: propTypes.string(),
  /**
   * 徽标类型
   */
  type: propTypes.string().def('text'),
  /**
   * 徽标尺寸
   */
  size: propTypes.string().def('small'),
  /**
   * 徽标内容
   */
  content: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  /**
   * 徽标背景颜色
   */
  color: propTypes.string().def(''),
  /**
   * 设置状态点的位置偏移，格式为 [x, y]
   */
  offset: propTypes.array().def([0, 0]),
  /**
   * 展示封顶的数字值;大于 maxCount 展示${maxCount}+,仅当 type 为 num
   */
  maxCount: propTypes.number().def(99),
  /**
   * 是否展示描边
   */
  showStroke: propTypes["boolean"]().def(false),
  /**
   * 是否展示徽标
   */
  hidden: propTypes["boolean"]().def(false)
};

var _createComponent = createComponent('badge'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: _defineProperty({}, Icon.name, Icon),
  props: props,
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var badgeContent = ref();
    // badge容器的class
    var badgeClassNames = computed(function () {
      var token = props.token;
      var classNames = _defineProperty({}, "".concat(className), true);
      if (typeClass.value) {
        classNames["".concat(typeClass.value)] = !token;
      }
      if (strokeClass.value) {
        classNames["".concat(strokeClass.value)] = !token;
      }
      if (token) {
        classNames["".concat(token)] = true;
      }
      return classNames;
    });
    // 不同类型的不同尺寸样式
    var typeClass = computed(function () {
      if (slots.content) return;
      return "".concat(className, "__").concat(props.type, "--").concat(props.size);
    });
    // 不同类型的描边样式
    var strokeClass = computed(function () {
      return "".concat(props.showStroke ? className + '__stroke' : '');
    });
    // 判断是否展示徽标
    var showBadge = computed(function () {
      if (props.hidden) {
        return false;
      }
      if (slots.content) {
        return true;
      }
      // 如果传入kid-token，则内容必显示
      if (props.token) {
        return true;
      }
      var type = props.type,
        content = props.content;
      return ['text', 'number'].includes(type) ? isDef(content) && content !== '' : true;
    });
    watch(function () {
      return props.content;
    }, function (newVal) {
      if (props.type === 'number') {
        var count = +newVal;
        var maxCount = props.maxCount;
        badgeContent.value = count > maxCount ? "".concat(maxCount, "+") : count;
      } else {
        badgeContent.value = newVal;
      }
    }, {
      immediate: true
    });
    return {
      badgeContent: badgeContent,
      badgeClassNames: badgeClassNames,
      className: className,
      typeClass: typeClass,
      strokeClass: strokeClass,
      showBadge: showBadge
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_icon = resolveComponent("sp-icon");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass("".concat(_ctx.className, "__wrapper"))
  }, [renderSlot(_ctx.$slots, "default"), withDirectives(createElementVNode("div", {
    "class": normalizeClass(_ctx.badgeClassNames),
    style: normalizeStyle({
      top: "".concat(_ctx.offset[0] || '', "px"),
      right: "".concat(_ctx.offset[1] || '', "px"),
      background: _ctx.color
    })
  }, [renderSlot(_ctx.$slots, "content", {}, function () {
    return [_ctx.type === 'warn' ? (openBlock(), createBlock(_component_sp_icon, {
      key: 0,
      name: "baseflat_warningprompt"
    })) : ['number', 'text'].includes(_ctx.type) ? (openBlock(), createElementBlock(Fragment, {
      key: 1
    }, [createTextVNode(toDisplayString(_ctx.badgeContent), 1 /* TEXT */)], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)) : createCommentVNode("v-if", true)];
  })], 6 /* CLASS, STYLE */), [[vShow, _ctx.showBadge]])], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/badge/badge.vue";

var _Badge = script;

export { _Badge as default };
